// extracted by mini-css-extract-plugin
module.exports = {"currencyBlock":"currencies_currencyBlock__ZiutW"};